export function AddFilesList(state = {}, action) {
    switch (action.type) {
        case 'ADD_FILES_LIST':
            return addFiles(state, action.obj)
        case 'ADD_FILES_OTHER':
            return addFilesOther(state, action.arr)
        default:
            return state
    }
}

function addFiles(state, obj) {
    console.log('addFiles 1:', state, obj)
    let result = Object.assign({}, state, obj)
    console.log('addFiles 2:', result)
    return result
}

function addFilesOther(state, arr) {
    console.log('addFilesOther 1:', state, arr)
    let result = Object.assign({}, state, {
        ['other']: arr,
    })
    console.log('addFilesOther 2:', result)
    return result
}
